import Axios from "@/Axios";


class UserService{

    async getUsers(data = {}){
        return await Axios.get(`wms.wms.api.user.get_users`, {
            params : data
        })
    }
    async getUsersByRole(data = {}){
        return await Axios.get(`wms.wms.api.user.get_users_by_role`, { 
            params : data
        })
    }

    async createUser(data){
        return await Axios.post("wms.wms.api.user.create_user", data)
    }

    async deleteUsers(users){
        const transformedUsers = users.map(item => ({ name: item }));
        return await Axios.delete("wms.wms.api.user.delete_user",{data:{users:transformedUsers}})
    }

    async getUser(email){
        return await Axios.get(`wms.wms.api.user.get_user_by_name`,{params : {email}})
    }

    async updateUser(data){
        return await Axios.put(`wms.wms.api.user.update_user`, data)
    }
}

export default (new UserService);